"use client";
import CountUp from "react-countup";

interface StatItem {
  num: number;
  text: string;
}

const stats: StatItem[] = [
  {
    num: 5,
    text: "Years of experience",
  },
  {
    num: 20,
    text: "Projects completed",
  },
  {
    num: 10,
    text: "Technologies Mastered",
  },
  {
    num: 10000,
    text: "Code commits",
  },
];

const Stats = () => {
  return (
    <section className="pt-4 pb-10 xl:pt-2 xl:pb-5 shrink-0">
      <div className="container mx-auto">
        <div className="flex flex-wrap gap-4 xl:gap-6 max-w-[80vw] mx-auto xl:max-w-none">
          {stats.map((item, index) => {
            return (
              <div
                className="flex-1 flex gap-3 xl:gap-4 items-center justify-center xl:justify-start cursor-target"
                key={index}
              >
                <CountUp
                  end={item.num}
                  duration={1.25}
                  delay={0}
                  useEasing
                  separator=","
                  className="inline-block shrink-0 text-right tabular-nums text-4xl xl:text-5xl font-extrabold cursor-target"
                />
                <p className="flex-1 min-w-0 leading-snug text-sm xl:text-base text-white/80 cursor-target">
                  {item.text}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Stats;
